import env from '@maui-mf/env'
import { pageViews } from './page-views'
import { userIdentification } from './user-identification'

let inited = false

const warn = message => {
  console.warn(`Could not load tracker 'gtag': ${message}`)
}

export const init = () => {
  if (inited) { return }

  if (!env.GA_MEASUREMENT_ID) {
    warn('expected GA_MEASUREMENT_ID to exist in env')
    return
  }

  if (!window.gtag) {
    warn('expected window.gtag to be defined')
    return
  }

  pageViews()
  userIdentification()

  inited = true
}
